import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-md border px-2 py-0.5 text-xs font-semibold leading-4 whitespace-nowrap",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground",
        // Tide status pairs (styles/tide/tide.css): the word carries the meaning; colour repeats it.
        ok: "border-transparent bg-[var(--tide-status-ok-bg)] text-[var(--tide-status-ok)]",
        caution: "border-transparent bg-[var(--tide-status-caution-bg)] text-[var(--tide-status-caution)]",
        danger: "border-transparent bg-[var(--tide-status-danger-bg)] text-[var(--tide-status-danger)]",
        missing: "border-transparent bg-[var(--tide-status-missing-bg)] text-[var(--tide-status-missing)]",
        withheld: "border-transparent bg-[var(--tide-status-withheld-bg)] text-[var(--tide-status-withheld)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
